export const reports = {
  reports: {
    pricingStatus: {
      pricingStatus: {
        table: {
          header: {
            multiplier: 'Multiplier',
            productAttr: 'Product Attribute Value',
            discount: 'Discount Value',
          },
        },
      },
      specialNetPricing: {
        table: {
          header: {
            catalog: 'Catalog',
            listPrice: 'List Price',
            netPrice: 'Net Price',
          },
        },
      },
      promoCodes: {
        noContent: 'Promotions Not Available.',
      },
    },
    creditSummary: {
      title: 'Credit Summary',
      paymentTerms: 'Payment Terms',
      openInvoiceTotals: 'Open Invoice Totals',
      openOrderTotals: 'Open Order Totals',
      avgPayDates: 'Avg Pay Dates',
      accountPayable: 'Account Payable',
      current: 'Current',
      pastDue1To30: '1-30 days past due',
      pastDue31To60: '31-60 days past due',
      pastDue61To90: '61-90 days past due',
      pastDue91To180: '91-180 days past due',
      pastDueOver180: 'Over 180 days past due',
      currentInvoices: 'Current Invoices',
      table: {
        header: {
          invoice: 'Invoice #',
          invoiceDate: 'Invoice Date',
          originalAmount: 'Original Amount',
          amoutDue: 'Amount Due',
          dueDate: 'Due Date',
          pO: 'PO #',
          status: 'Status',
          creditAdjustments: 'Credit Adjustments',
          order: 'Order #',
        },
      },
    },
    paymentHistory: {
      table: {
        header: {
          paymentDate: 'Payment Date',
          paymentAmount: 'Payment Amount',
          paymentMethod: 'Payment Method',
          transactionId: 'Transaction ID',
          status: 'Status',
        },
      },
    },
    noContent: 'Information Not Available.',
    programStatus: {
      title: 'Program Status',
      ytdPurchase: 'YTD Purchase',
      pricingStatus: 'Pricing Status',
      purchaseSummary: 'Purchase Summary',
      creditSummary: 'Credit Summary',
      paymentHistory: 'Payment History',
      programList: 'Program List',
      promoCodes: 'Promo Codes',
    },
    purchaseSummaryDetails: {
      table: {
        header: {
          partNumber: 'Part #',
          productDescription: 'Product Description',
          quantity: 'Quantity',
          sellingPrice: 'Selling Price',
          totalPrice: 'Total Price',
        },
      },
    },
    purchaseSummary: {
      annualPurchases: 'Annual Purchases',
      periodName: 'Period Name',
      purchaseDollars: 'Purchase Dollars',
      noContent: 'No Content Available',
      info: 'Purchase dollars for a specific month will only reflect invoiced items and dollars for that month.',
      example: 'Example: If order is placed on April 30th and invoiced in May, the sales dollars will appear in the month of May, not April.',
      note: 'If order is placed on April 30th and invoiced in May, the sales dollars will appear in the month of May, not April.',
    },
  },
};